import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ConversaoFinal() {
  return <section id="conversão-final" className="bg-background py-[200px] px-6 flex flex-col items-center justify-center text-center">
      <div className="max-w-4xl mx-auto flex flex-col items-center">
        <h2 className="text-foreground font-default text-4xl md:text-5xl lg:text-6xl font-semibold mb-12 tracking-tight">
          Pronto para posicionar sua empresa?
        </h2>
        
        <Link to="#">
          <Button size="lg" className="rounded-full h-16 px-12 text-lg font-medium shadow-md hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
            Falar com especialista
          </Button>
        </Link>
      </div>
    </section>;
}